import { doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { db } from '../../../../firebase';

const updatePresence = (userId: string, isOnline: boolean, includeLogin = false) =>
  updateDoc(doc(db!, 'users', userId), {
    isOnline,
    lastActiveAt: serverTimestamp(),
    ...(includeLogin ? { lastLogin: serverTimestamp() } : {}),
  });

export const markUserOnline = (userId: string, includeLogin = false) =>
  updatePresence(userId, true, includeLogin);

export const markUserOffline = (userId: string) =>
  updatePresence(userId, false);
